module.exports = __webpack_public_path__ + "static/media/memories_15.b20b7003.jpg";